export default "__VITE_ASSET__DiCl$LWI__"